(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mis-bundle"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__misBundleInit) return;
    window.__misBundleInit = true;

    var S = { qty: 1, v1: null, v2: null, v2touched: false };

    function rootEl() { return document.querySelector('.mis-bundle'); }
    function readData(r) {
      try { return JSON.parse(r.querySelector('[data-mis-variants]').textContent); } catch (e) { return null; }
    }
    function qtyInputs() {
      return document.querySelectorAll('form[action*="/cart/add"] input[name="quantity"], product-form-component input[name="quantity"], quantity-selector-component input');
    }
    function setQty(q) {
      qtyInputs().forEach(function (qi) {
        qi.value = q;
        qi.dispatchEvent(new Event('input', { bubbles: true }));
        qi.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    function findV(d, id) {
      id = parseInt(id, 10);
      for (var i = 0; i < d.variants.length; i++) if (d.variants[i].id === id) return d.variants[i];
      return null;
    }
    function pickerVariantId() {
      var s = document.querySelector('variant-picker script[type="application/json"]');
      try { if (s) { var id = JSON.parse(s.textContent).id; if (id) return id; } } catch (e) {}
      return null;
    }
    function applyToPicker(v, d) {
      d.names.forEach(function (name, i) {
        setTimeout(function () {
          var inputs = document.querySelectorAll('variant-picker input[type="radio"]');
          for (var k = 0; k < inputs.length; k++) {
            var inp = inputs[k];
            if (inp.dataset.optionName === name && inp.value === v.options[i]) {
              if (!inp.checked) inp.click();
              break;
            }
          }
        }, i * 350);
      });
    }
    function fmt(c, cur) {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'pl', { style: 'currency', currency: cur }).format(c / 100); }
      catch (e) { return (c / 100).toFixed(2) + ' ' + cur; }
    }
    function render() {
      var r = rootEl(); if (!r) return;
      var d = readData(r); if (!d) return;
      var pct = parseInt(r.dataset.pct, 10), cur = r.dataset.currency;
      if (S.v1 === null) { S.v1 = pickerVariantId() || d.selected; }
      if (S.v2 === null) { S.v2 = S.v1; }
      var a = findV(d, S.v1), b = findV(d, S.v2);
      if (!a) return; if (!b) b = a;
      r.querySelectorAll('select[data-slot]').forEach(function (sel) {
        var want = sel.dataset.slot === '2' ? S.v2 : S.v1;
        if (String(sel.value) !== String(want)) sel.value = String(want);
      });
      r.querySelectorAll('.mis-bundle__opt').forEach(function (o) {
        var q = parseInt(o.dataset.qty, 10);
        var on = (q === S.qty);
        o.classList.toggle('is-active', on);
        o.setAttribute('aria-pressed', on ? 'true' : 'false');
        var tot = o.querySelector('[data-total]'), old = o.querySelector('[data-old]'), sv = o.querySelector('[data-saved]');
        if (q === 1) { if (tot) tot.textContent = fmt(a.price, cur); }
        else {
          var base = a.price + b.price, disc = Math.round(base * (100 - pct) / 100);
          if (tot) tot.textContent = fmt(disc, cur);
          if (old) old.textContent = fmt(base, cur);
          if (sv) sv.textContent = fmt(base - disc, cur);
        }
      });
    }
    function syncFromPicker() {
      var r = rootEl(); if (!r) return;
      var pid = pickerVariantId();
      if (pid && pid !== S.v1) { S.v1 = pid; if (!S.v2touched) S.v2 = pid; }
      var list = qtyInputs();
      if (list.length) { var q = parseInt(list[0].value, 10) || 1; S.qty = q >= 2 ? 2 : 1; }
      render();
    }
    function showMsg(t) {
      var m = document.querySelector('.mis-bundle__msg'); if (!m) return;
      m.textContent = t || ''; m.hidden = !t;
    }

    document.addEventListener('change', function (e) {
      var sel = e.target.closest && e.target.closest('.mis-bundle select[data-slot]');
      if (sel) {
        var r = rootEl(), d = readData(r);
        var card = sel.closest('.mis-bundle__opt');
        S.qty = parseInt(card.dataset.qty, 10);
        if (sel.dataset.slot === '2') { S.v2 = parseInt(sel.value, 10); S.v2touched = true; }
        else {
          S.v1 = parseInt(sel.value, 10);
          if (!S.v2touched) S.v2 = S.v1;
          var v = findV(d, S.v1); if (v) applyToPicker(v, d);
        }
        setQty(S.qty);
        showMsg('');
        render();
        return;
      }
      setTimeout(syncFromPicker, 400);
    });

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest) return;

      var card = t.closest('.mis-bundle__opt');
      if (card && !t.closest('select, label')) {
        S.qty = parseInt(card.dataset.qty, 10);
        setQty(S.qty); showMsg(''); render();
        return;
      }
      if (card) return;

      var btn = t.closest('product-form-component button, form[action*="/cart/add"] button');
      if (btn && !btn.closest('.mis-bundle') && !btn.closest('quantity-selector-component') && (btn.type === 'submit' || btn.name === 'add')) {
        if (S.qty === 2 && S.v1 !== null && S.v2 !== null && S.v1 !== S.v2) {
          e.preventDefault(); e.stopImmediatePropagation();
          var old = btn.textContent; btn.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: S.v1, quantity: 1 }, { id: S.v2, quantity: 1 }] })
          }).then(function (res) { return res.json().then(function (j) { return { ok: res.ok, j: j }; }); })
            .then(function (res) {
              if (res.ok) { window.location.href = '/cart'; }
              else { btn.disabled = false; showMsg((res.j && (res.j.description || res.j.message)) || 'Nie udało się dodać do koszyka.'); }
            })
            .catch(function () { btn.disabled = false; showMsg('Nie udało się dodać do koszyka.'); });
        }
        return;
      }
      if (t.closest('variant-picker, quantity-selector-component')) setTimeout(syncFromPicker, 400);
    }, true);

    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('mis-bundle__opt')) {
        e.preventDefault();
        S.qty = parseInt(e.target.dataset.qty, 10); setQty(S.qty); render();
      }
    });
    document.addEventListener('shopify:section:load', function () { setTimeout(syncFromPicker, 100); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncFromPicker); else syncFromPicker();
  })();
  } catch(e) { console.error(e); }
})();

})();
